module.exports = __webpack_public_path__ + "img/symbol_s03.e92266f.svg";